import { EnvProvider } from '@zenbusiness/application-commons-env';

import ClickstreamWrapper from '#client/ClickstreamWrapper';
import AppWrapper from '#client/Providers';
import { FederatedAppRoutes } from '#client/routes';

const ENV = process.env.BUILD_ENV;

function FederatedApp() {
  return (
    <EnvProvider env={ENV}>
      <EnvProvider env={`${ENV.DEFAULT_SEGMENT}/env?v=${ENV.RELEASE_VERSION}`}>
        <AppWrapper federated>
          <ClickstreamWrapper>
            <FederatedAppRoutes />
          </ClickstreamWrapper>
        </AppWrapper>
      </EnvProvider>
    </EnvProvider>
  );
}

export default FederatedApp;
